import { h } from "preact";
import { useEffect } from "preact/hooks";
import { addNoScroll, removeContextMenu, removeNoScroll } from "../lib/helper";

const Popup = ({ children, setVisible }) => {
  useEffect(() => {
    addNoScroll();
    return () => {
      removeNoScroll();
    };
  }, []);

  return (
    <div
      id="popup"
      onClick={() => {
        removeContextMenu();
        setVisible(false);
      }}
    >
      <div className="modal-content">
        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
